<h1 mat-dialog-title>Skapa ny media</h1>
<div mat-dialog-content
     class="py-2">
  <flow-media-create [isModal]="true"
                             (mediaSaved)="onSaved($event)"
                             (cancel)="onCancel()"></flow-media-create>
</div>
